import { DataKits } from "../@types"

export const KITS_MODAL_STATE = '[ KITS ] Kits Modal State'

export interface IKitsModalState {
    type: typeof KITS_MODAL_STATE
}

export const GET_KIT_FOR_UPDATE = '[ KITS ] Get Kit For Update'

export interface IGetKitForUpdate {
    type: typeof GET_KIT_FOR_UPDATE
    payload: DataKits
}

export const IS_KITS_FOR_UPDATE ='[ KITS ] Is Kit For Update'

export interface IIsKitForUpdate {
    type: typeof IS_KITS_FOR_UPDATE
    payload: boolean
}

export const SWITCH_KITS_REFRESH_TABLE = '[ KITS ] Switch Kits Refresh Table'

export interface ISwitchKitsRefreshTable {
    type: typeof SWITCH_KITS_REFRESH_TABLE
    payload: boolean
}

export const SWITCH_KITS_PRODUCTS_REFRESH_TABLE = '[ KITS ] Switch Kits Products Refresh Table'

export interface ISwitchKitsProductsRefreshTable {
    type: typeof SWITCH_KITS_PRODUCTS_REFRESH_TABLE
    payload: boolean
}
